import { render, staticRenderFns } from "./XdocProjectPlanForWord.vue?vue&type=template&id=006a6b2e&scoped=true"
import script from "./XdocProjectPlanForWord.vue?vue&type=script&lang=ts"
export * from "./XdocProjectPlanForWord.vue?vue&type=script&lang=ts"
import style0 from "./XdocProjectPlanForWord.vue?vue&type=style&index=0&id=006a6b2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006a6b2e",
  null
  
)

export default component.exports